import { createValidation } from '../../utils/validation';
import manualConfig from './manualConfig';

const createManualValidation = () => createValidation(manualConfig.fields);

export const validateManualData = createManualValidation();
export const createManualValidationSchema = createManualValidation;
export default createManualValidation;
